/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Delete_Confirm_TitleInputs */

const en_doc_delete_confirm_title = /** @type {(inputs: Doc_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete document?`)
};

const pt_br2_doc_delete_confirm_title = /** @type {(inputs: Doc_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir documento?`)
};

/**
* | output |
* | --- |
* | "Delete document?" |
*
* @param {Doc_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_delete_confirm_title = /** @type {((inputs?: Doc_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Delete_Confirm_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_delete_confirm_title(inputs)
	return pt_br2_doc_delete_confirm_title(inputs)
});